export const ComponentTypes = Object.freeze({
  ANIMATION_PROGRESS: 'AnimationProgress',
  ARTICLE_CARD: 'ArticleCard',
  ASSISTANT_WELCOME: 'AssistantWelcome',
  BUSINESS_COST_RESULTS: 'BusinessCostResults',
  BUSINESS_ENTITY_ADVISOR_RESULTS: 'BusinessEntityAdvisorResults',
  BUSINESS_ENTITY_ADVISOR_V2_RESULTS: 'BusinessEntityAdvisorV2Results',
  BUSINESS_IDEA_RESULTS: 'BusinessIdeaResults',
  BUSINESS_NAME_RESULTS: 'BusinessNameResults',
  BUSINESS_RESULTS: 'BusinessResults',
  BUTTON_PROMPT: 'ButtonPrompt',
  CAROUSEL: 'Carousel',
  CHAT_ERROR_MESSAGE: 'ChatErrorMessage',
  CHECK_IN: 'CheckIn',
  CHOICE_FLOW: 'ChoiceFlow',
  DIVIDER: 'Divider',
  FEEDBACK_FORM: 'FeedbackForm',
  LOGO: 'Logo',
  MESSAGE: 'Message',
  MESSAGE_WITH_CTA: 'MessageWithCTA',
  MESSAGE_WITH_LOGO: 'MessageWithLogo',
  SLOGAN_GENERATOR_RESULTS: 'SloganGeneratorResults',
  SUPPORT_CARD: 'SupportCard',
  TEXT: 'text',
  THINKING_ANIMATION: 'ThinkingAnimation',
  TRACKER: 'Tracker',
  UPSELL_CARD: 'UpsellCard',
  USER_RESPONSE: 'UserResponse',
  PRODUCT_CARD: 'ProductCard',
  MARKET_ANALYSIS_REPORT: 'MarketAnalysisReport',
  STANDALONE_TOOL_CARD: 'StandaloneToolCard'
});

export const THREAD_MODES = Object.freeze({
  ANONYMOUS: 'anonymous',
  STANDALONE: 'standalone',
  BUSINESS: 'business',
  STARTER: 'starter'
});

export const VALID_ROLES = Object.freeze(['user', 'assistant', 'system']);

export const MESSAGE_TYPES = Object.freeze(['greet', 'text', 'skip']);

export const WELCOME_PROMPT_BUTTONS = [
  {
    id: 'create-blueprint',
    text: 'Create my Blueprint',
    message: 'Create my Blueprint',
    messageType: 'invoke',
    agentName: 'blueprint'
  },
  {
    id: 'continue-blueprint',
    text: 'Continue your Blueprint',
    message: 'Continue your Blueprint',
    messageType: 'invoke',
    agentName: 'blueprint'
  },
  {
    id: 'velo-can-do',
    text: 'Show me what Velo can do',
    message: 'Show me what Velo can do'
  },
  {
    id: 'start-business',
    text: 'How can Velo help me start a business?',
    message: 'How can Velo help me start a business?'
  },
  {
    id: 'choose-business-name',
    text: 'Help me choose a business name',
    message: 'Help me choose a business name'
  },
  {
    id: 'before-launch',
    text: 'What do I need before I launch?',
    message: 'What do I need before I launch?'
  }
];

// VeloCard configuration presets
export const VELO_QA_CONFIGS = Object.freeze({
  'COMPLIANCE.businessLicenses.notPurchased': {},
  'COMPLIANCE.businessLicenses.formationPendingBlfPurchased': {},
  'COMPLIANCE.businessLicenses.blrPending': {},
  'COMPLIANCE.businessLicenses.blrComplete': {},
  'COMPLIANCE.businessLicenses.blfFundsRequired': {},
  'COMPLIANCE.businessLicenses.blfInProgress': {},
  'COMPLIANCE.overview.default': {},
  'COMPLIANCE.registeredAgent.default': {},
  'COMPLIANCE.trademarks.default': {},
  'COMPLIANCE.amendments.default': {},
  'COMPLIANCE.annualReports.default': {},
  'business-licenses': {
    title: 'Have questions about licenses?',
    subtitle:
      'Velo is the ZenBusiness AI guide to help you with all your questions and needs about running a business.',
    prompts: [
      { id: '1', text: 'How can I find out if my business is an LLC or Corporation?' },
      { id: '2', text: 'How can I find out the domestic state for my company?' },
      {
        id: '3',
        text: 'For the registered agent service, should I use my business legal name or DBA?'
      },
      { id: '4', text: 'How long does it take to get my registered agent switched to ZenBusiness?' }
    ]
  },
  'formation-help': {
    title: 'Have questions? Velo can help.',
    subtitle: 'Ask Velo anything about starting your business.',
    prompts: [
      { id: '1', text: "What's the difference between LLC and Corporation?" },
      { id: '2', text: 'Which state should I form my business in?' },
      { id: '3', text: 'Do I need a DBA?' },
      { id: '4', text: 'What are the ongoing compliance requirements?' }
    ]
  },
  'general-help': {
    title: 'Have questions? Velo can help.',
    subtitle:
      'Velo is the ZenBusiness AI guide to help you with all your questions and needs about running a business. You can ask it any question or use the most frequent questions asked on this page.',
    prompts: [
      { id: '1', text: 'How can I find out if my business is an LLC or Corporation?' },
      { id: '2', text: 'How can I find out the domestic state for my company?' },
      {
        id: '3',
        text: 'For the registered agent service, should I use my business legal name or DBA?'
      },
      { id: '4', text: 'How long does it take to get my registered agent switched to ZenBusiness?' }
    ]
  },
  'ra-getting-started': {
    title: 'Have questions? Velo can help.',
    subtitle:
      'Velo is the ZenBusiness AI guide to help you with all your questions and needs about running a business. You can ask it any question or use the most frequent questions asked on this page.',
    prompts: [
      { id: '1', text: 'How can I find out if my business is an LLC or Corporation?' },
      { id: '2', text: 'How can I find out the domestic state for my company?' },
      {
        id: '3',
        text: 'For the registered agent service, should I use my business legal name or DBA?'
      },
      { id: '4', text: 'How long does it take to get my registered agent switched to ZenBusiness?' }
    ]
  },
  'ra-contact-info': {
    title: '',
    subtitle:
      "We'll need one main contact in case the state or our team has questions about your filing. Velo can explain why this info matters and how we use it safely.",
    prompts: [
      { id: '1', text: 'For the registered agent service, why do you need my contact info?' },
      { id: '2', text: 'For the registered agent service, who can I use as the main contact?' },
      {
        id: '3',
        text: 'Once my registered agent is swapped, will my contact information be public?'
      },
      {
        id: '4',
        text: 'For the registered agent service, what happens if I skip the contact info step?'
      }
    ]
  },
  'ra-existing-agent': {
    title: '',
    subtitle:
      "Your business must always have a registered agent on file with the state. Velo can help you understand what that means, how to find your current agent, and what to do if you don't have one.",
    prompts: [
      {
        id: '1',
        text: 'Where can I find who is listed as the current registered agent for my business?'
      },
      {
        id: '2',
        text: "For the registered agent service, is there an issue if I don't have a registered agent?"
      },
      {
        id: '3',
        text: 'For the registered agent service, what if I have multiple registered agents currently?'
      },
      { id: '4', text: 'Are all businesses required to have a registered agent?' }
    ]
  },
  'ra-plan-selection': {
    title: '',
    subtitle:
      "Not sure which plan fits your business best? Velo can explain what's included in each option, how Worry-Free Compliance helps, and when it makes sense to add it.",
    prompts: [
      {
        id: '1',
        text: 'For the registered agent service, what is the difference between just registered agent and adding worry free compliance?'
      },
      {
        id: '2',
        text: 'For the registered agent service, is it worth me adding the worry free compliance product?'
      },
      {
        id: '3',
        text: 'When completing my registered agent purchase, when will I be billed for the service?'
      },
      {
        id: '4',
        text: 'For the registered agent service, what happens if I decline worry free compliance?'
      }
    ]
  },
  'ra-multi-state': {
    title: '',
    subtitle:
      'Expanding into more states? Velo can help you understand when you need a Registered Agent in multiple states and how ZenBusiness can handle them all for you.',
    prompts: [
      { id: '1', text: 'How do I know if I need a Registered Agent in another state?' },
      { id: '2', text: 'Can ZenBusiness cover all my states as my registered agent?' },
      {
        id: '3',
        text: 'For the registered agent service, what if I know that I will expand to other states later?'
      },
      {
        id: '4',
        text: 'For the registered agent service, do I need to register as a foreign entity?'
      }
    ]
  },
  'ra-checkout': {
    title: '',
    subtitle:
      "Have questions about billing or your order? Velo can explain how charges work, when renewals happen, and what's included in your plan so you can check out confidently.",
    prompts: [
      {
        id: '1',
        text: 'For the registered agent service, what is the 60-day money back guarantee?'
      },
      {
        id: '2',
        text: 'For the registered agent service, what kinds of payment do you accept?'
      },
      { id: '3', text: 'For the registered agent service, do you accept non-US credit cards?' },
      { id: '4', text: 'For the registered agent service, do you save my payment info?' }
    ]
  },
  'ra-order-complete': {
    title: '',
    subtitle:
      "You're all set! Velo can walk you through what happens next — including how we'll file your documents, when you'll get updates, and how to track your order.",
    prompts: [
      { id: '1', text: 'How long will it take to complete the Registered Agent change?' },
      { id: '2', text: 'Where can I track my order status?' },
      { id: '3', text: 'Will I need to do anything else?' },
      { id: '4', text: 'What is the actual address for my registered agent?' }
    ]
  }
});

export const PARTNER_LOGOS = {
  // Avalara: '/s2/vector/partnership-avalara.svg',
  '1-800Accountant': '/s2/vector/partnership-1-800accountant.svg',
  BankofAmerica: '/s2/vector/partnership-bankofamerica.svg',
  constantContactEmail: '/s2/vector/partnership-constant-contact-email.svg',
  Next: '/s2/vector/partnership-next.svg',
  Ocoya: '/s2/vector/partnership-ocoya.svg'
};

export const INDUSTRY_IMAGES = {
  construction: '/s2/raster/customer-industry-construction.png',
  creativeIndustries: '/s2/raster/customer-industry-creative-industries.png',
  education: '/s2/raster/customer-industry-education.png',
  financial: '/s2/raster/customer-industry-financial.png',
  foodAndHospitality: '/s2/raster/customer-industry-food-and-hospitality.png',
  generic: '/s2/raster/customer-industry-generic.png',
  healthCareAndWellbeing: '/s2/raster/customer-industry-health-care-and-wellbeing.png',
  homeRemodelingAndRenovations: '/s2/raster/customer-industry-home-remodeling-and-renovations.png',
  professionalTechnicalServices: '/s2/raster/customer-industry-professional-technical-services.png',
  realEstate: '/s2/raster/customer-industry-real-estate.png',
  sellingOnline: '/s2/raster/customer-industry-selling-online.png',
  technology: '/s2/raster/customer-industry-technology.png',
  transportation: '/s2/raster/customer-industry-transportation.png'
};

export const ARTICLE_IMAGES_TITLE_MAP = {
  '3 steps to crafting your best pitch':
    '/s2/raster/article-generation-5-steps-to-setting-up-your-finances.png',
  '4 common questions about compliance':
    '/s2/raster/article-generation-4-common-questions-about-compliance.png',
  '4 tips for a great candidate interview':
    '/s2/raster/article-generation-4-tips-for-a-great-candidate-interview.png',
  '5 must-haves for financial success':
    '/s2/raster/article-generation-5-must-haves-for-financial-success.png',
  '5 questions about buying a business vs. a franchise':
    '/s2/raster/article-generation-5-questions-about-buying-a-business-vs-a-franchise.png',
  '5 questions to ask before expansion':
    '/s2/raster/article-generation-5-questions-to-ask-before-expansion.png',
  '5 steps to setting up your finances':
    '/s2/raster/article-generation-5-steps-to-setting-up-your-finances.png',
  '5 strategies to steal from sales':
    '/s2/raster/article-generation-5-strategies-to-steal-from-sales.png',
  '5 things to know about licensing and permit requirements': '/s2/raster/notes-laptop-desk.png',
  '5 things to know about the difference between personal and business taxes':
    '/s2/raster/review-documents-partnership.png',
  '5 ways to close a deal': '/s2/raster/article-generation-5-ways-to-close-a-deal.png',
  '6 common business contracts': '/s2/raster/article-generation-6-common-business-contracts.png',
  '6 tactics to grow your business':
    '/s2/raster/article-generation-6-tactics-to-grow-your-business.png',
  '6 tools to develop rockstar employees':
    '/s2/raster/article-generation-6-tools-to-develop-rockstar-employees.png',
  'A few things businesses need to be legally compliant':
    '/s2/raster/article-generation-a-few-things-businesses-need-to-be-legally-compliant.png',
  'A guide to 1:1s with your employees':
    '/s2/raster/article-generation-a-guide-to-11s-with-your-employees.png',
  'A quick guide to A/B testing': '/s2/raster/article-generation-a-quick-guide-to-ab-testing.png',
  'All about non-disclosure agreements':
    '/s2/raster/article-generation-all-about-non-disclosure-agreements.png',
  'Are you ready for funding?': '/s2/raster/article-generation-are-you-ready-for-funding.png',
  'Balance sheets: what to know': '/s2/raster/article-generation-balance-sheets-what-to-know.png',
  'Boost business with sales tactics':
    '/s2/raster/article-generation-boost-business-with-sales-tactics.png',
  'Brand messaging at the awareness stage':
    '/s2/raster/article-generation-brand-messaging-at-the-awareness-stage.png',
  'Brand messaging at the consideration stage':
    '/s2/raster/article-generation-brand-messaging-at-the-consideration-stage.png',
  'Brand messaging at the conversion stage':
    '/s2/raster/article-generation-brand-messaging-at-the-conversion-stage.png',
  'Breaking even: what you need to know':
    '/s2/raster/article-generation-breaking-even-what-you-need-to-know.png',
  'Build the right website for your business':
    '/s2/raster/article-generation-build-the-right-website-for-your-business.png',
  'Build your marketing funnel': '/s2/raster/article-generation-build-your-marketing-funnel.png',
  'Building a crowdfunding campaign':
    '/s2/raster/article-generation-building-a-crowdfunding-campaign.png',
  'Building your crowd for crowdfunding':
    '/s2/raster/article-generation-building-your-crowd-for-crowdfunding.png',
  'Business terms to know: Part 1': '/s2/raster/article-generation-get-to-know-your-customer.png',
  'Business terms to know: Part 2': '/s2/raster/article-generation-get-to-know-your-customer.png',
  'Buying a business vs. a franchise':
    '/s2/raster/article-generation-buying-a-business-vs-a-franchise.png',
  'Check out the competition': '/s2/raster/article-generation-check-out-the-competition.png',
  'Choosing the right HR option': '/s2/raster/article-generation-choosing-the-right-hr-option.png',
  'Choosing the right pricing strategy':
    '/s2/raster/article-generation-choosing-the-right-pricing-strategy.png',
  'Connecting social media to business success':
    '/s2/raster/article-generation-connecting-social-media-to-business-success.png',
  'Create your own B2B sales process':
    '/s2/raster/article-generation-create-your-own-b2b-sales-process.png',
  'Creating a customer mindset map':
    '/s2/raster/article-generation-creating-a-customer-mindset-map.png',
  'Defining your target market': '/s2/raster/article-generation-defining-your-target-market.png',
  'Do you know how much your customers are worth?':
    '/s2/raster/article-generation-do-you-know-how-much-your-customers-are-worth.png',
  'Do you need an official business address?':
    '/s2/raster/article-generation-do-you-need-an-official-business-address.png',
  'Do you need to protect your business idea?':
    '/s2/raster/article-generation-do-you-need-to-protect-your-business-idea.png',
  "Do's and don'ts for giving (and getting) feedback":
    '/s2/raster/article-generation-dos-and-donts-for-giving-and-getting-feedback.png',
  'Does your product match your market?':
    '/s2/raster/article-generation-does-your-product-match-your-market.png',
  'Does your website need a designer?':
    '/s2/raster/article-generation-does-your-website-need-a-designer.png',
  'Employment agreements: What to know':
    '/s2/raster/article-generation-employment-agreements-what-to-know.png',
  'Establishing your fiscal year':
    '/s2/raster/article-generation-establishing-your-fiscal-year.png',
  'Facebook marketing 101': '/s2/raster/article-generation-facebook-marketing-101.png',
  "Financial reports don't have to be scary":
    '/s2/raster/article-generation-financial-reports-dont-have-to-be-scary.png',
  'Forming a C-Corp or S-Corp': '/s2/raster/article-generation-forming-a-c-corp-or-s-corp.png',
  'Forming a general partnership':
    '/s2/raster/article-generation-forming-a-general-partnership.png',
  'Forming a sole proprietorship':
    '/s2/raster/article-generation-forming-a-sole-proprietorship.png',
  'Forming an LLC': '/s2/raster/article-generation-forming-an-llc.png',
  'Freelancers & independent contractor agreements':
    '/s2/raster/article-generation-freelancers-independent-contractor-agreements.png',
  'Get to know your customer': '/s2/raster/article-generation-get-to-know-your-customer.png',
  'Get your team on the same page with clear goals':
    '/s2/raster/article-generation-get-your-team-on-the-same-page-with-clear-goals.png',
  'Getting ready for rewards-based crowdfunding':
    '/s2/raster/article-generation-getting-ready-for-rewards-based-crowdfunding.png',
  'Getting started with social media':
    '/s2/raster/article-generation-getting-started-with-social-media.png',
  'Guiding customers through the marketing funnel':
    '/s2/raster/article-generation-guiding-customers-through-the-marketing-funnel.png',
  "How do you 'balance the books'?":
    '/s2/raster/article-generation-how-do-you-balance-the-books.png',
  'How do you stay legally compliant?':
    '/s2/raster/article-generation-how-do-you-stay-legally-compliant.png',
  'How Google Ads can help your business grow':
    '/s2/raster/article-generation-how-google-ads-can-help-your-business-grow.png',
  'How product-based businesses win customers':
    '/s2/raster/article-generation-how-product-based-businesses-win-customers.png',
  'How service-based businesses win customers':
    '/s2/raster/article-generation-how-service-based-businesses-win-customers.png',
  "How to build a 'dream team' culture":
    '/s2/raster/article-generation-how-to-build-a-dream-team-culture.png',
  'How to build a growth strategy':
    '/s2/raster/article-generation-how-to-build-a-growth-strategy.png',
  'How to create website content that wins':
    '/s2/raster/article-generation-how-to-create-website-content-that-wins.png',
  'How to design a business model':
    '/s2/raster/article-generation-how-to-design-a-business-model.png',
  'How to find your unique value proposition':
    '/s2/raster/article-generation-how-to-find-your-unique-value-proposition.png',
  'How to improve your Google Ads campaign':
    '/s2/raster/article-generation-how-to-improve-your-google-ads-campaign.png',
  "How to interview for the '2 out of 3' formula":
    '/s2/raster/article-generation-how-to-interview-for-the-2-out-of-3-formula.png',
  'How to make your website look professional':
    '/s2/raster/article-generation-how-to-make-your-website-look-professional.png',
  "How to measure your website's impact":
    '/s2/raster/article-generation-how-to-measure-your-websites-impact.png',
  'How to navigate the business loan maze':
    '/s2/raster/article-generation-how-to-navigate-the-business-loan-maze.png',
  'How to open a new location': '/s2/raster/article-generation-how-to-open-a-new-location.png',
  'How to plan your social media content':
    '/s2/raster/article-generation-how-to-plan-your-social-media-content.png',
  'How to set the right marketing goals':
    '/s2/raster/article-generation-how-to-set-the-right-marketing-goals.png',
  'How to set up a Google Ads campaign':
    '/s2/raster/article-generation-how-to-set-up-a-google-ads-campaign.png',
  'How to set up an equity crowdfunding campaign':
    '/s2/raster/article-generation-how-to-set-up-an-equity-crowdfunding-campaign.png',
  'How to set up your Google Business profile':
    '/s2/raster/article-generation-how-to-set-up-your-google-business-profile.png',
  'How to use your sales pipeline to boost sales':
    '/s2/raster/article-generation-how-to-use-your-sales-pipeline-to-boost-sales.png',
  'How to write a business plan': '/s2/raster/article-generation-how-to-write-a-business-plan.png',
  'How to write a lean startup business plan':
    '/s2/raster/article-generation-how-to-write-a-lean-startup-business-plan.png',
  'How will your customers find you?':
    '/s2/raster/article-generation-how-will-your-customers-find-you.png',
  'Instagram marketing 101': '/s2/raster/article-generation-instagram-marketing-101.png',
  'Invest in marketing but make it smart':
    '/s2/raster/article-generation-invest-in-marketing-but-make-it-smart.png',
  'Is equity crowdfunding right for your business?':
    '/s2/raster/article-generation-is-equity-crowdfunding-right-for-your-business.png',
  'Is rewards-based crowdfunding right for you?':
    '/s2/raster/article-generation-is-rewards-based-crowdfunding-right-for-you.png',
  'Is your Google Ads campaign working for you?':
    '/s2/raster/article-generation-is-your-google-ads-campaign-working-for-you.png',
  'Is your website secure?': '/s2/raster/article-generation-is-your-website-secure.png',
  'LinkedIn marketing 101': '/s2/raster/article-generation-linkedin-marketing-101.png',
  'Making your crowdfunding campaign a success':
    '/s2/raster/article-generation-making-your-crowdfunding-campaign-a-success.png',
  'Manage anything using the quadrant method':
    '/s2/raster/article-generation-manage-anything-using-the-quadrant-method.png',
  'Moving business across state lines':
    '/s2/raster/article-generation-moving-business-across-state-lines.png',
  'Opening a business bank account':
    '/s2/raster/article-generation-opening-a-business-bank-account.png',
  'Paid vs organic marketing: what to know':
    '/s2/raster/article-generation-paid-vs-organic-marketing-what-to-know.png',
  'Pick your accounting method': '/s2/raster/article-generation-pick-your-accounting-method.png',
  'Picking the right PEO for your business':
    '/s2/raster/article-generation-picking-the-right-peo-for-your-business.png',
  'Ready to take your business online?':
    '/s2/raster/article-generation-ready-to-take-your-business-online.png',
  "ROI and ROAS: What's the difference?":
    '/s2/raster/article-generation-roi-and-roas-whats-the-difference.png',
  "Sales vs. marketing: what's the difference?":
    '/s2/raster/article-generation-sales-vs-marketing-whats-the-difference.png',
  'Set up your business contact info':
    '/s2/raster/article-generation-set-up-your-business-contact-info.png',
  'Setting up an independent contractor agreement':
    '/s2/raster/article-generation-setting-up-an-independent-contractor-agreement.png',
  'Should you buy a business?': '/s2/raster/article-generation-should-you-buy-a-business.png',
  'Should you consider equity?': '/s2/raster/article-generation-should-you-consider-equity.png',
  'Should you get into franchising?':
    '/s2/raster/article-generation-should-you-get-into-franchising.png',
  'Should your website have a tracking pixel?':
    '/s2/raster/article-generation-should-your-website-have-a-tracking-pixel.png',
  'Small business compliance FAQs':
    '/s2/raster/article-generation-small-business-compliance-faqs.png',
  'Tapping into alternative funding solutions':
    '/s2/raster/article-generation-tapping-into-alternative-funding-solutions.png',
  "The '2 out of 3' formula for hiring success":
    '/s2/raster/article-generation-the-2-out-of-3-formula-for-hiring-success.png',
  'The 3-step formula for growth':
    '/s2/raster/article-generation-the-3-step-formula-for-growth.png',
  'The 4 stages of a business': '/s2/raster/article-generation-the-4-stages-of-a-business.png',
  'The 4 types of intellectual property':
    '/s2/raster/article-generation-the-4-types-of-intellectual-property.png',
  'The 5 types of growth strategies':
    '/s2/raster/article-generation-the-5-types-of-growth-strategies.png',
  'The 7 steps to B2B sales': '/s2/raster/article-generation-the-7-steps-to-b2b-sales.png',
  'The basics of a marketing plan':
    '/s2/raster/article-generation-the-basics-of-a-marketing-plan.png',
  'The basics of bookkeeping': '/s2/raster/article-generation-the-basics-of-bookkeeping.png',
  "The beginner's guide to display ads":
    '/s2/raster/article-generation-the-beginners-guide-to-display-ads.png',
  "The beginner's guide to MVPs": '/s2/raster/article-generation-the-beginners-guide-to-mvps.png',
  'The different types of business models':
    '/s2/raster/article-generation-the-different-types-of-business-models.png',
  'The inbound sales method': '/s2/raster/article-generation-the-inbound-sales-method.png',
  'The lowdown on government loans':
    '/s2/raster/article-generation-the-lowdown-on-government-loans.png',
  'The Sandler sales method': '/s2/raster/article-generation-the-sandler-sales-method.png',
  'The SNAP sales method': '/s2/raster/article-generation-the-snap-sales-method.png',
  'The solution selling method': '/s2/raster/article-generation-the-solution-selling-method.png',
  'The SPIN sales method': '/s2/raster/article-generation-the-spin-sales-method.png',
  'TikTok marketing 101': '/s2/raster/article-generation-tiktok-marketing-101.png',
  'Time to talk business plans': '/s2/raster/article-generation-time-to-talk-business-plans.png',
  'Tips to stay ahead of small business compliance':
    '/s2/raster/article-generation-tips-to-stay-ahead-of-small-business-compliance.png',
  'Track customers with a sales pipeline':
    '/s2/raster/article-generation-track-customers-with-a-sales-pipeline.png',
  'Twitter marketing 101': '/s2/raster/article-generation-twitter-marketing-101.png',
  'Understanding the Corporate Transparency Act':
    '/s2/raster/article-generation-what-are-corporate-bylaws.png',
  'Understanding the technical side of SEO':
    '/s2/raster/article-generation-understanding-the-technical-side-of-seo.png',
  'What are corporate bylaws?': '/s2/raster/article-generation-what-are-corporate-bylaws.png',
  'What are information pages?': '/s2/raster/article-generation-what-are-information-pages.png',
  'What are SEO keywords and phrases?':
    '/s2/raster/article-generation-what-are-seo-keywords-and-phrases.png',
  'What are the types of equity crowdfunding?':
    '/s2/raster/article-generation-what-are-the-types-of-equity-crowdfunding.png',
  "What does 'being compliant' mean?":
    '/s2/raster/article-generation-what-does-being-compliant-mean.png',
  'What does it mean to be compliant?':
    '/s2/raster/article-generation-what-does-it-mean-to-be-compliant.png',
  'What does your website need to succeed?':
    '/s2/raster/article-generation-what-does-your-website-need-to-succeed.png',
  'What is a cash flow statement?':
    '/s2/raster/article-generation-what-is-a-cash-flow-statement.png',
  'What is a chart of accounts?': '/s2/raster/article-generation-what-is-a-chart-of-accounts.png',
  'What is an income statement?': '/s2/raster/article-generation-what-is-an-income-statement.png',
  'What licenses and permits does your business need?':
    '/s2/raster/article-generation-what-licenses-and-permits-does-your-business-need.png',
  'What to know about licensing contracts':
    '/s2/raster/article-generation-what-to-know-about-licensing-contracts.png',
  'What to know about operating agreements':
    '/s2/raster/article-generation-what-to-know-about-operating-agreements.png',
  'What to know about order forms':
    '/s2/raster/article-generation-what-to-know-about-order-forms.png',
  'What to know about service agreements':
    '/s2/raster/article-generation-what-to-know-about-service-agreements.png',
  'What to know about terms of use agreements':
    '/s2/raster/article-generation-what-to-know-about-terms-of-use-agreements.png',
  'What type of funding do you need?':
    '/s2/raster/article-generation-what-type-of-funding-do-you-need.png',
  'What type of organic marketing do you need?':
    '/s2/raster/article-generation-what-type-of-organic-marketing-do-you-need.png',
  "What's a business model?": '/s2/raster/article-generation-whats-a-business-model.png',
  "What's a partnership agreement?":
    '/s2/raster/article-generation-whats-a-partnership-agreement.png',
  "What's a pricing strategy?": '/s2/raster/article-generation-whats-a-pricing-strategy.png',
  "What's a value proposition?": '/s2/raster/article-generation-whats-a-value-proposition.png',
  "What's crowdfunding?": '/s2/raster/article-generation-whats-crowdfunding.png',
  "What's organic marketing?": '/s2/raster/article-generation-whats-organic-marketing.png',
  "What's SEO?": '/s2/raster/article-generation-whats-seo.png',
  "What's the marketing funnel?": '/s2/raster/article-generation-whats-the-marketing-funnel.png',
  "What's your sales method?": '/s2/raster/article-generation-whats-your-sales-method.png',
  "What's your social media content strategy?":
    '/s2/raster/article-generation-whats-your-social-media-content-strategy.png',
  'When to get accounting help': '/s2/raster/article-generation-when-to-get-accounting-help.png',
  'Where should you put your content?':
    '/s2/raster/article-generation-where-should-you-put-your-content.png',
  'Why accounting is important': '/s2/raster/article-generation-why-accounting-is-important.png',
  'Why measuring your marketing ROI is important':
    '/s2/raster/article-generation-why-measuring-your-marketing-roi-is-important.png',
  'Why separate personal and business banking?': '/s2/raster/sign-document-professional.png',
  'Why should new businesses track expenses?': '/s2/raster/expense-tracking-pottery-store.png',
  'Why to have quarterly team get-togethers':
    '/s2/raster/article-generation-why-to-have-quarterly-team-get-togethers.png',
  'Why you need a mentor': '/s2/raster/article-generation-why-you-need-a-mentor.png',
  'Why your sales process should put people first':
    '/s2/raster/article-generation-why-your-sales-process-should-put-people-first.png',
  'Why your website needs to be mobile-friendly':
    '/s2/raster/article-generation-why-your-website-needs-to-be-mobile-friendly.png',
  'Win customers with a new website':
    '/s2/raster/article-generation-win-customers-with-a-new-website.png',
  'Win customers with email marketing':
    '/s2/raster/article-generation-win-customers-with-email-marketing.png',
  'Winning your first e-commerce customers':
    '/s2/raster/article-generation-winning-your-first-e-commerce-customers.png',
  'YouTube marketing 101': '/s2/raster/article-generation-youtube-marketing-101.png'
};

export const HIGHLIGHT_TEXT_PREFIXES = [
  'go to',
  'open',
  'view',
  'get',
  'complete',
  'file',
  'upgrade',
  'change',
  'form',
  'register',
  'build',
  'search',
  'design'
];

// Transition Types for centralized transition management
export const TRANSITION_TYPES = Object.freeze({
  VISIT_LOADING: {
    title: 'Setting Up Assistant',
    subtitle: 'Validating visit context...',
    logoState: 'answering'
  },
  ENTITY_LOADING: {
    title: 'Setting Up Assistant',
    subtitle: 'Validating business context...',
    logoState: 'answering'
  },
  THREAD_CREATING: {
    title: 'Initializing Chat',
    subtitle: 'Creating your assistant session...',
    logoState: 'answering'
  },
  THREAD_CREATING_RETRY: {
    title: 'Initializing Chat',
    subtitle: (retryCount) => `Retry attempt ${retryCount}...`,
    logoState: 'answering'
  },
  THREAD_LOADING: {
    title: 'Loading conversation thread...',
    subtitle: 'Loading your conversation...',
    logoState: 'answering'
  },
  COMING_SOON: {
    title: 'Coming Soon',
    subtitle: "The Velo assistant isn't enabled yet.",
    logoState: 'default'
  },
  CONNECTION_ERROR: {
    title: 'Connection Error',
    subtitle: 'Unable to connect to the assistant. Please try again.',
    logoState: 'warning'
  },
  VALIDATION_ERROR: {
    title: 'Invalid Message',
    subtitle: 'Please try again with a different message.',
    logoState: 'warning'
  },
  CONNECTION_TIMEOUT: {
    title: 'Connection Timeout',
    subtitle: 'The request took too long to complete. Please try again.',
    logoState: 'warning'
  },
  ALMOST_READY: {
    title: 'Almost Ready',
    subtitle: 'Preparing your session...',
    logoState: 'answering'
  },
  THREAD_ERROR_AUTH: {
    title: 'Unable to Start Chat',
    subtitle: 'Authentication error. Please try refreshing the page.',
    logoState: 'default'
  },
  THREAD_ERROR_NETWORK: {
    title: 'Unable to Start Chat',
    subtitle: 'Network connection issue. Please check your internet connection.',
    logoState: 'default'
  },
  THREAD_ERROR_GENERIC: {
    title: 'Unable to Start Chat',
    subtitle: 'Failed to create chat session.',
    logoState: 'default'
  },
  BUSINESS_ENTITY_ADVISOR_GENERATING: {
    title: 'Generating your entity overview...',
    subtitle: 'This may take a few moments.',
    logoState: 'default'
  },
  BUSINESS_ENTITY_ADVISOR_LOADING: {
    title: 'Loading Form...',
    subtitle: 'This may take a few moments.',
    logoState: 'default'
  },
  BUSINESS_COST_ESTIMATOR_GENERATING: {
    suptitle: 'Generating your business cost estimates...',
    loadingVariant: 'tools'
  },
  BUSINESS_COST_ESTIMATOR_LOADING: {
    suptitle: 'Loading your business cost estimates...',
    loadingVariant: 'tools'
  },
  BUSINESS_IDEA_GENERATING: {
    suptitle: 'Generating your Business Idea with Velo...',
    loadingVariant: 'tools'
  },
  BUSINESS_IDEA_LOADING: {
    suptitle: 'Loading your Business Idea with Velo...',
    loadingVariant: 'tools'
  },
  GENERATING_RESULTS: {
    title: 'Generating your report...',
    subtitle: 'Analyzing your inputs and preparing insights.',
    logoState: 'answering'
  },
  LOADING: {
    title: 'Loading...',
    subtitle: 'Please wait...',
    logoState: 'answering'
  },
  BUSINESS_NAME_GENERATING: {
    suptitle: 'Generating your business names...',
    loadingVariant: 'tools'
  },
  BUSINESS_NAME_LOADING: {
    suptitle: 'Loading your business names...',
    loadingVariant: 'tools'
  }
});

// TODO: move to theme
export const veloBorderPrimary = '#ccc';
export const newBlueRebrand = '#3971E7';
export const secondaryMain = '#33F28B';

export const BASE_STYLES = {
  border: '1px solid transparent',
  transition: 'all 0.2s ease-in-out',
  background: `linear-gradient(#fff, #fff) padding-box, linear-gradient(249deg, ${newBlueRebrand} 27.22%, ${secondaryMain} 100%) border-box`
};

export const CTA_TEXT_TO_CLICKSTREAM_ELEMENT = Object.freeze({
  'open website editor': 'website_agent_cta',
  'go to business licenses': 'business_license_agent_cta',
  'go to dashboard': 'dashboard_cta'
});

export const CLICKSTREAM_COMMON_PROPS = Object.freeze({
  appSection: 'velo-chat',
  dynamicProperties: {
    ai_project_name: 'velo_chat'
  }
});

export const selectAnimation = {
  default: { intro: [0, 1], loop: [0, 240], outro: [240, 241] },
  awaiting: { intro: [250, 270], loop: [270, 280], outro: [280, 300] },
  answering: { intro: [300, 320], loop: [320, 360], outro: [360, 380] },
  processing: { intro: [380, 400], loop: [400, 440], outro: [440, 460] },
  warning: { intro: [460, 480], loop: [480, 720], outro: [720, 740] }
};

const CLOUDINARY_BASE_URL = 'https://res.cloudinary.com/zenbusiness/raw/upload';
const CLOUDINARY_PROJECT = 'shared-assets';

export const LOTTIE_AVATAR_PATH = `${CLOUDINARY_BASE_URL}/v1751552559/${CLOUDINARY_PROJECT}/s2/animation/lottie/velo-avatar-platform.json`;

export const LOTTIE_TOOLS_LOADING_PATH = `${CLOUDINARY_BASE_URL}/v1768582576/${CLOUDINARY_PROJECT}/s2/animation/lottie/velo-tools-loading_compressed.json`;

export const USER_FEEDBACK = Object.freeze({
  GOOD: 'GOOD',
  NEUTRAL: 'NEUTRAL',
  BAD: 'BAD'
});

export const TOAST_MESSAGES = Object.freeze({
  THANK_YOU: 'Thank you for your feedback'
});

export const BUSINESS_IDEA_SECTIONS = [
  {
    id: 'summary',
    field: 'summary',
    title: 'Summary',
    icon: 'icon-business-ideas-overview.png'
  },
  {
    id: 'whyThisWorksForYou',
    field: 'why_this_works_for_you',
    title: 'Why this works for you',
    icon: ''
  },
  {
    id: 'businessOverview',
    field: 'business_overview',
    title: 'Business Overview',
    icon: 'icon-business-ideas-overview.png'
  },
  {
    id: 'targetCustomers',
    field: 'target_customers',
    title: 'Target Customers',
    icon: 'icon-business-ideas-customers.png'
  },
  {
    id: 'revenueModel',
    field: 'revenue_model',
    title: 'Revenue Model',
    icon: 'icon-business-ideas-revenue.png'
  },
  {
    id: 'startupCostsInvestment',
    field: 'startup_costs_&_investment',
    title: 'Startup Costs & Investment',
    icon: 'icon-business-ideas-costs.png'
  },
  {
    id: 'marketingStrategy',
    field: 'marketing_strategy',
    title: 'Marketing Strategy',
    icon: 'icon-business-ideas-strategy.png'
  },
  {
    id: 'risksChallenges',
    field: 'risks_&_challenges',
    title: 'Risks & Challenges',
    icon: 'icon-business-ideas-challenges.png'
  },
  {
    id: 'growthOpportunities',
    field: 'growth_opportunities',
    title: 'Growth Opportunities',
    icon: 'icon-business-ideas-growth.png'
  },
  {
    id: 'similar_businesses',
    field: 'similar_businesses',
    title: 'Similar Businesses',
    icon: 'icon-business-ideas-overview.png'
  },
  {
    id: 'domains',
    field: 'domains',
    title: 'Domain Availability',
    icon: 'icon-business-ideas-overview.png'
  },
  {
    id: 'trademark',
    field: 'trademark',
    title: 'Trademark Information',
    icon: 'icon-business-ideas-overview.png'
  }
];

export const BUSINESS_COST_SECTIONS = [
  {
    id: 'summary',
    title: 'Summary',
    icon: null,
    isBubble: true
  },
  {
    id: 'formation',
    title: 'Formation',
    icon: 'icon-business-ideas-overview.png'
  },
  {
    id: 'licensesPermits',
    title: 'Licenses & Permits',
    icon: 'icon-planning-tools-permits.png'
  },
  {
    id: 'taxes',
    title: 'Taxes',
    icon: 'icon-business-ideas-costs.png'
  },
  {
    id: 'annualReport',
    title: 'Annual Report',
    icon: 'icon-planning-tools-annual-report.png'
  },
  {
    id: 'registeredAgent',
    title: 'Registered Agent',
    icon: 'icon-planning-tools-RA.png'
  },
  {
    id: 'bookkeepingTools',
    title: 'Bookkeeping Tools',
    icon: 'icon-planning-tools-bookkeeping.png'
  },
  {
    id: 'operatingEquipment',
    title: 'Operating Equipment',
    icon: 'icon-planning-tools-equipment.png'
  },
  {
    id: 'officeOrPhysicalLocation',
    title: 'Office or Physical Location',
    icon: 'icon-planning-tools-location.png'
  },
  {
    id: 'websiteMarketingExpenses',
    title: 'Website & Marketing Expenses',
    icon: 'icon-planning-tools-website.png'
  },
  {
    id: 'generalOperatingCosts',
    title: 'General Operating Costs',
    icon: 'icon-planning-tools-general.png'
  },
  {
    id: 'estimatedTotal',
    title: 'Estimated Total',
    icon: 'icon-planning-tools-total.png',
    showDisclaimer: true,
    disclaimer: '*Disclaimer: These are only estimates. Actual costs may vary.*'
  }
];

export const BUSINESS_ENTITY_ADVISOR_SECTIONS = [
  // Overview section
  {
    id: 'overview',
    subsections: [
      { id: 'summary', title: 'Summary', icon: 'icon-business-ideas-overview.png' },
      { id: 'understandingConfidenceLevel', icon: 'icon-velo-tools-info.png' },
      { id: 'whyThisConfidenceLevel', icon: 'icon-velo-tools-question.png' },
      { id: 'whyThisRecommendation', icon: 'icon-velo-tools-thinking.png' }
    ]
  },

  // Comparison section
  {
    id: 'comparison',
    subsections: [{ id: 'comparison' }]
  },

  // Tax Impact sections
  {
    id: 'taxImpact',
    subsections: [
      { id: 'taxImplications', icon: 'icon-business-ideas-costs.png' },
      {
        id: 'taxComparison',
        icon: 'icon-planning-tools-costs.png',
        subsections: [
          { id: 'comparison' },
          {
            id: 'disclaimer',
            title: 'Important',
            isBubble: true,
            content:
              'These are simplified examples for illustration. Actual taxes depend on your specific income level, deductions, state taxes, and other factors. Always consult a CPA for personalized tax planning.'
          }
        ]
      },
      { id: 'stateTaxation', icon: 'icon-business-name-local.png' },
      { id: 'tips', icon: 'icon-velo-tools-bulb.png' }
    ]
  },

  // State Information sections
  {
    id: 'stateInformation',
    subsections: [
      { id: 'stateRequirements', title: 'State Requirements', icon: 'icon-business-name-local.png' }
    ]
  }
];

/**
 * Market Analysis sections configuration
 * Defines the order and structure of sections in market analysis reports
 */
export const MARKET_ANALYSIS_SECTIONS = [
  { id: 'executiveSummary', title: 'Executive Summary' },
  { id: 'marketOverview', title: 'Market Overview' },
  { id: 'marketGrowthTrend', title: 'Market Growth Trend' },
  { id: 'marketTrends', title: 'Market Trends' },
  { id: 'customerSegmentation', title: 'Customer Segmentation' },
  { id: 'competitiveLandscape', title: 'Competitive Landscape' },
  { id: 'competitorProfiles', title: 'Competitor Profiles' },
  { id: 'swotAnalysis', title: 'SWOT Analysis' },
  { id: 'actionableRecommendations', title: 'Actionable Recommendations' },
  { id: 'roiImpactLayer', title: 'ROI Impact Analysis' },
  { id: 'implementationGuidance', title: 'Implementation Roadmap' },
  { id: 'suggestedNextSteps', title: 'Suggested Next Steps (30-60 Days)' },
  { id: 'methodology', title: 'Methodology & Data Sources' }
];

export const BLUEPRINT_MIGRATE_KEY = 'blueprint_migrate_visitUuid';
export const BLUEPRINT_MIGRATE_THREAD_KEY = 'blueprint_migrate_threadUuid';

export const STANDALONE_THREAD_STATUS = Object.freeze({
  complete: 'complete',
  in_progress: 'in_progress',
  error: 'error'
});
